// extracted by mini-css-extract-plugin
module.exports = {"preloader":"Preloader_preloader__3QIgV","loader":"Preloader_loader__3VHRu"};